import { isSet } from "src/util/string";

export function formatBankAccountLabel(account: { ibanShort: string, accountOwner?: string }): string {
    return isSet(account.accountOwner)
        ? `${account.ibanShort} (${account.accountOwner!.trim()})`
        : account.ibanShort;
}

export function formatIbanShort(iban: string): string {
    if (!iban || iban.length < 2) return "";
    let short = iban.substring(0, 4) + "...";
    if (iban.length > 4) short += iban.substring(Math.max(4, iban.length - 4), iban.length);
    return short;
}
